import { useState } from 'react';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { useDocumentListData } from 'modules/box-strorage/hooks/useDocumentListData';
import DocumentList from 'modules/box-strorage/components/DocumentList/DocumentList';
import { Button } from '@library/buttons';
import { Link } from 'react-router-dom';
import { removeDocument } from '@api/services/box-storage.service';
import { toast } from 'react-toastify';
import { IBoxStorageFile } from '@api/models';

const DocumentListPage = () => {
    const { documentList, isLoading, setData } = useDocumentListData();
    const [deletingFileId, setDeletingFileId] = useState<string | null>(null);

    return (
        <PageTemplate>
            <PageHeading className="flex justify-between">
                Box Storage
                <Link to="/box-storage/upload" className="text-primary hover:underline" rel="noopener noreferrer">
                    <Button>Upload</Button>
                </Link>
            </PageHeading>

            <DocumentList
                isLoading={isLoading}
                documents={documentList}
                deletingFileId={deletingFileId}
                onDelete={async (fileId) => {
                    try {
                        setDeletingFileId(fileId);
                        await removeDocument(fileId);
                        setData((prev) => (prev || []).filter((doc: IBoxStorageFile) => doc._id !== fileId));
                        toast.success('File deleted');
                    } catch (err) {
                        toast.error('Failed to delete file');
                    } finally {
                        setDeletingFileId(null);
                    }
                }}
            />
        </PageTemplate>
    );
};

export default DocumentListPage;
